/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import * as React from 'react';
import { useGlobalState } from 'src/core/hooks/useGlobalState';

/**
 * Loads the publish slots information for the current app
 * if it was not loaded before.
 */
export const usePublishSettings = () => {
    const { rootStore, dispatcher } = useGlobalState();

    React.useEffect(() => {
        if (rootStore.currentLuisAppStore.publishSlots.staging) {
            dispatcher.dispatch('getPublishSettings', { isStaging: true });
        }
        if (rootStore.currentLuisAppStore.publishSlots.production) {
            dispatcher.dispatch('getPublishSettings', { isStaging: false });
        }
    }, []);

    return {
        productionSlot: rootStore.currentLuisAppStore.publishSlots.production,
        stagingSLot: rootStore.currentLuisAppStore.publishSlots.staging
    };
};
